module.exports = __webpack_public_path__ + "img/phone-cadw.a9e85abd.png";